export default "__VITE_ASSET__CQuld7rP__"